import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Routes,
  Route,
  Link,
  useLocation,
  useMatch,
  Outlet,
} from "react-router-dom"; // Import Outlet
import {
  ADMIN_DASHBOARD_PATH,
  COACH_LEADERBOARD_PATH,
  COACH_EXERCISES_PATH,
  COACH_QUESTIONS_PATH,
} from "../routes/navigation/navigation_paths"; // Import path constants
// import { setDomainesList } from '../redux/reducers/domaines'; // Assuming this reducer exists
// import ReduxAxios from '../redux/actions'; // Assuming this actions file exists
// import axios from 'axios';
// import { SERVER_ROUTE } from '../routes/api/api_routes'; // Assuming this route constant exists
import {
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiAward,
  FiMapPin,
  FiClock,
  FiCode,
  FiLayers,
  FiHome,
  FiList,
  FiChevronRight,
  FiChevronLeft,
  FiCheckCircle,
  FiUsers,
  FiTrendingUp, // Added necessary icons
} from "react-icons/fi";
import "./CoachDashboard.css";

// Import new components
import DashboardHeader from "../components/coach/DashboardHeader";
import QuizzesView from "../Pages/coach/QuizzesView";
import DashboardOverviewView from "../Pages/coach/DashboardOverviewView";
import BakelistesView from "./coach/UtilisateursView";
import DomainesView from "../Pages/coach/DomainesView";
import TechnologiesView from "../Pages/coach/TechnologiesView";
import NiveauxView from "../Pages/coach/NiveauxView";

// import NiveauxView from '../Pages/coach/NiveauxView'; // Corrected import path casing

// Import RTK Query hooks
import {
  useGetDomainesQuery,
  useAddDomaineMutation,
  useUpdateDomaineMutation,
  useDeleteDomaineMutation,
  useGetTechnologiesQuery,
  useAddTechnologyMutation,
  useUpdateTechnologyMutation,
  useDeleteTechnologyMutation,
  useGetNiveauxQuery,
  useAddNiveauMutation,
  useUpdateNiveauMutation,
  useDeleteNiveauMutation,
  useGetCategoriesQuery,
  useAddCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useGetExercisesQuery,
  useAddExerciseMutation,
  useUpdateExerciseMutation,
  useDeleteExerciseMutation,
  useGetQuestionsQuery,
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useGetParcoursQuery,
  useAddParcoursMutation,
  useUpdateParcoursMutation,
  useDeleteParcoursMutation,
} from "../redux/api/coachApi";

const CoachDashboard = () => {
  const dispatch = useDispatch();
  const location = useLocation(); // Get current location
  // Assuming domaines state is managed in Redux - This will be replaced by RTK Query
  // const domainesList = useSelector(state => state.domaines.domainesList);

  // State for managing different sections and data
  const [newDomaine, setNewDomaine] = useState("");
  // const [loading, setLoading] = useState(false); // RTK Query handles loading
  const [error, setError] = useState(""); // Keep for form validation errors
  const [editingDomaine, setEditingDomaine] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  // Remove activeSection state
  // const [activeSection, setActiveSection] = useState('dashboard');

  // State for each entity (keep existing state management for forms)
  // const [technologies, setTechnologies] = useState([]); // Replaced by RTK Query
  // const [niveaux, setNiveaux] = useState([]); // Replaced by RTK Query
  // const [categories, setCategories] = useState([]); // Replaced by RTK Query
  // const [exercises, setExercises] = useState([]); // Replaced by RTK Query
  // const [questions, setQuestions] = useState([]); // Replaced by RTK Query
  // const [quizzes, setQuizzes] = useState([]); // Replaced by RTK Query

  // Technologies state for form and editing
  const [newTechnology, setNewTechnology] = useState({ name: "" });
  const [editingTechnology, setEditingTechnology] = useState(null);

  // Niveaux state for form and editing
  const [newNiveau, setNewNiveau] = useState({ name: "" });
  const [editingNiveau, setEditingNiveau] = useState(null);

  // Categories state for form and editing
  const [newCategory, setNewCategory] = useState({ nom: "" });
  const [editingCategory, setEditingCategory] = useState(null);

  // Parcours state for form and editing
  const [newParcours, setNewParcours] = useState({ name: "" });
  const [editingParcours, setEditingParcours] = useState(null);

  // Exercises state for form and editing
  const [newExercise, setNewExercise] = useState({
    intitule: "",
    maximum_marks: 4,
    technology: "",
    niveau: "",
    resolution_time: 30,
    reponses: [
      {
        intitule: "",
        is_correct: false,
        test_unitaire: "",
      },
    ],
  });
  const [editingExercise, setEditingExercise] = useState(null);

  // Questions state for form and editing
  const [newQuestion, setNewQuestion] = useState({
    html: "",
    is_published: false,
    maximum_marks: 4,
    technology: "",
    niveau: "",
    categorie: "",
  });
  const [editingQuestion, setEditingQuestion] = useState(null);

  // RTK Query hooks for fetching data
  const {
    data: domainesList,
    isLoading: isLoadingDomaines,
    error: errorDomaines,
  } = useGetDomainesQuery();
  const {
    data: technologies,
    isLoading: isLoadingTechnologies,
    error: errorTechnologies,
  } = useGetTechnologiesQuery();
  const {
    data: niveaux,
    isLoading: isLoadingNiveaux,
    error: errorNiveaux,
  } = useGetNiveauxQuery();
  const {
    data: categories,
    isLoading: isLoadingCategories,
    error: errorCategories,
  } = useGetCategoriesQuery();
  const {
    data: exercises,
    isLoading: isLoadingExercises,
    error: errorExercises,
  } = useGetExercisesQuery();
  const {
    data: questions,
    isLoading: isLoadingQuestions,
    error: errorQuestions,
  } = useGetQuestionsQuery();
  const {
    data: parcours,
    isLoading: isLoadingParcours,
    error: errorParcours,
  } = useGetParcoursQuery();

  // RTK Query hooks for mutations
  const [addDomaine, { isLoading: isAddingDomaine }] = useAddDomaineMutation();
  const [updateDomaine, { isLoading: isUpdatingDomaine }] =
    useUpdateDomaineMutation();
  const [deleteDomaine, { isLoading: isDeletingDomaine }] =
    useDeleteDomaineMutation();

  const [addTechnology, { isLoading: isAddingTechnology }] =
    useAddTechnologyMutation();
  const [updateTechnology, { isLoading: isUpdatingTechnology }] =
    useUpdateTechnologyMutation();
  const [deleteTechnology, { isLoading: isDeletingTechnology }] =
    useDeleteTechnologyMutation();

  const [addNiveau, { isLoading: isAddingNiveau }] = useAddNiveauMutation();
  const [updateNiveau, { isLoading: isUpdatingNiveau }] =
    useUpdateNiveauMutation();
  const [deleteNiveau, { isLoading: isDeletingNiveau }] =
    useDeleteNiveauMutation();

  const [addCategory, { isLoading: isAddingCategory }] =
    useAddCategoryMutation();
  const [updateCategory, { isLoading: isUpdatingCategory }] =
    useUpdateCategoryMutation();
  const [deleteCategory, { isLoading: isDeletingCategory }] =
    useDeleteCategoryMutation();

  const [addExercise, { isLoading: isAddingExercise }] =
    useAddExerciseMutation();
  const [updateExercise, { isLoading: isUpdatingExercise }] =
    useUpdateExerciseMutation();
  const [deleteExercise, { isLoading: isDeletingExercise }] =
    useDeleteExerciseMutation();

  const [addQuestion, { isLoading: isAddingQuestion }] =
    useAddQuestionMutation();
  const [updateQuestion, { isLoading: isUpdatingQuestion }] =
    useUpdateQuestionMutation();
  const [deleteQuestion, { isLoading: isDeletingQuestion }] =
    useDeleteQuestionMutation();

  const [addParcours, { isLoading: isAddingParcours }] =
    useAddParcoursMutation();
  const [updateParcours, { isLoading: isUpdatingParcours }] =
    useUpdateParcoursMutation();
  const [deleteParcours, { isLoading: isDeletingParcours }] =
    useDeleteParcoursMutation();

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  // Function to check if a navigation item is active
  const isNavLinkActive = (path) => {
    // Check if the current location exactly matches the path for the dashboard
    if (path === ADMIN_DASHBOARD_PATH) {
      return location.pathname === path;
    }
    // For other routes, check if the current location starts with the item's path
    return location.pathname.startsWith(path);
  };

  // --- Refactored Handlers using RTK Query ---

  // Add or update parcours
  const handleParcoursSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingParcours) {
        await updateParcours({
          id: editingParcours.id,
          ...newParcours,
        }).unwrap();
      } else {
        await addParcours(newParcours).unwrap();
      }
      setNewParcours({ name: "", categorie: "", description: "" });
      setEditingParcours(null);
    } catch (error) {
      console.error("Error submitting parcours:", error);
    }
  };

  // Edit parcours
  const handleEditParcours = (p) => {
    setEditingParcours(p);
    setNewParcours({
      name: p.name,
      categorie: p.categorie,
      description: p.description || "",
    });
  };

  // Delete parcours
  const handleDeleteParcours = async (id) => {
    if (window.confirm("Supprimer ce parcours ?")) {
      try {
        await deleteParcours(id).unwrap();
      } catch (error) {
        console.error("Error deleting parcours:", error);
      }
    }
  };

  // Add domaine handler
  const handleAddDomaine = async (e) => {
    e.preventDefault();
    if (!newDomaine.trim()) {
      setError("Le nom du domaine est requis.");
      return;
    }
    // setLoading(true); // RTK Query handles loading
    setError("");
    try {
      await addDomaine({ name: newDomaine }).unwrap();
      setNewDomaine("");
    } catch (err) {
      setError("Erreur lors de l'ajout du domaine.");
      // console.error("Error adding domaine:", err);
    }
    // finally { setLoading(false); } // RTK Query handles loading
  };

  // Edit domaine handler
  const handleEditDomaine = (domaine) => {
    setEditingDomaine(domaine);
    setNewDomaine(domaine.name);
  };

  // Update domaine handler
  const handleUpdateDomaine = async (e) => {
    e.preventDefault();
    if (!newDomaine.trim()) {
      setError("Le nom du domaine est requis.");
      return;
    }
    // setLoading(true); // RTK Query handles loading
    setError("");
    try {
      await updateDomaine({ id: editingDomaine.id, name: newDomaine }).unwrap();
      setNewDomaine("");
      setEditingDomaine(null);
    } catch (err) {
      setError("Erreur lors de la mise à jour du domaine.");
      // console.error("Error updating domaine:", err);
    }
    // finally { setLoading(false); } // RTK Query handles loading
  };

  // Delete domaine handler
  const handleDeleteDomaine = async (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer ce domaine ?")) {
      try {
        await deleteDomaine(id).unwrap();
      } catch (err) {
        setError("Erreur lors de la suppression du domaine.");
        // console.error("Error deleting domaine:", err);
      }
    }
  };

  // Add or update technology
  const handleTechnologySubmit = async (e) => {
    e.preventDefault();
    // const token = localStorage.getItem('access'); // Not needed with RTK Query baseQuery
    try {
      if (editingTechnology) {
        await updateTechnology({
          id: editingTechnology.id,
          ...newTechnology,
        }).unwrap();
      } else {
        await addTechnology(newTechnology).unwrap();
      }
      setNewTechnology({ name: "" });
      setEditingTechnology(null);
      // fetchTechnologies(); // Not needed, RTK Query invalidatesTags handles refetching
    } catch (error) {
      console.error("Error submitting technology:", error);
    }
  };

  // Edit technology
  const handleEditTechnology = (tech) => {
    setEditingTechnology(tech);
    setNewTechnology({ name: tech.name });
  };

  // Delete technology
  const handleDeleteTechnology = async (id) => {
    if (window.confirm("Supprimer cette technologie ?")) {
      try {
        await deleteTechnology(id).unwrap();
        // fetchTechnologies(); // Not needed, RTK Query invalidatesTags handles refetching
      } catch (error) {
        console.error("Error deleting technology:", error);
      }
    }
  };

  // Add or update niveau
  const handleNiveauSubmit = async (e) => {
    e.preventDefault();
    // const token = localStorage.getItem('access'); // Not needed with RTK Query baseQuery
    try {
      if (editingNiveau) {
        await updateNiveau({ id: editingNiveau.id, ...newNiveau }).unwrap();
      } else {
        await addNiveau(newNiveau).unwrap();
      }
      setNewNiveau({ name: "" });
      setEditingNiveau(null);
      // fetchNiveaux(); // Not needed, RTK Query invalidatesTags handles refetching
    } catch (error) {
      console.error("Error submitting niveau:", error);
    }
  };

  // Edit niveau
  const handleEditNiveau = (niv) => {
    setEditingNiveau(niv);
    setNewNiveau({ name: niv.name });
  };

  // Delete niveau
  const handleDeleteNiveau = async (id) => {
    if (window.confirm("Supprimer ce niveau ?")) {
      try {
        await deleteNiveau(id).unwrap();
        // fetchNiveaux(); // Not needed, RTK Query invalidatesTags handles refetching
      } catch (error) {
        console.error("Error deleting niveau:", error);
      }
    }
  };

  // Add or update category
  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    // const token = localStorage.getItem('access'); // Not needed with RTK Query baseQuery
    try {
      if (editingCategory) {
        await updateCategory({
          id: editingCategory.id,
          ...newCategory,
        }).unwrap();
      } else {
        await addCategory(newCategory).unwrap();
      }
      setNewCategory({ nom: "" });
      setEditingCategory(null);
      // fetchCategories(); // Not needed, RTK Query invalidatesTags handles refetching
    } catch (error) {
      console.error("Error submitting category:", error);
    }
  };

  // Edit category
  const handleEditCategory = (cat) => {
    setEditingCategory(cat);
    setNewCategory({ nom: cat.nom });
  };

  // Delete category
  const handleDeleteCategory = async (id) => {
    if (window.confirm("Supprimer cette catégorie ?")) {
      try {
        await deleteCategory(id).unwrap();
        // fetchCategories(); // Not needed, RTK Query invalidatesTags handles refetching
      } catch (error) {
        console.error("Error deleting category:", error);
      }
    }
  };

  // Add or update exercise
  const handleExerciseSubmit = async (e) => {
    e.preventDefault();
    // const token = localStorage.getItem('access'); // Not needed with RTK Query baseQuery
    try {
      if (editingExercise) {
        await updateExercise({
          id: editingExercise.id,
          ...newExercise,
        }).unwrap();
      } else {
        await addExercise(newExercise).unwrap();
      }
      setNewExercise({
        intitule: "",
        maximum_marks: 4,
        technology: "",
        niveau: "",
        resolution_time: 30,
        reponses: [
          {
            intitule: "",
            is_correct: false,
            test_unitaire: "",
          },
        ],
      });
      setEditingExercise(null);
      // fetchExercises(); // Not needed, RTK Query invalidatesTags handles refetching
    } catch (error) {
      console.error("Error submitting exercise:", error);
    }
  };

  // Edit exercise
  const handleEditExercise = (ex) => {
    setEditingExercise(ex);
    setNewExercise({
      intitule: ex.intitule,
      maximum_marks: ex.maximum_marks,
      technology: ex.technology,
      niveau: ex.niveau,
      resolution_time: ex.resolution_time,
      reponses: ex.reponses || [
        {
          intitule: "",
          is_correct: false,
          test_unitaire: "",
        },
      ],
    });
  };

  // Delete exercise
  const handleDeleteExercise = async (id) => {
    if (window.confirm("Supprimer cet exercice ?")) {
      try {
        await deleteExercise(id).unwrap();
        // fetchExercises(); // Not needed, RTK Query invalidatesTags handles refetching
      } catch (error) {
        console.error("Error deleting exercise:", error);
      }
    }
  };

  // Add response to exercise - need to check if this is still used in the forms
  const addResponse = () => {
    setNewExercise((prev) => ({
      ...prev,
      reponses: [
        ...prev.reponses,
        {
          intitule: "",
          is_correct: false,
          test_unitaire: "",
        },
      ],
    }));
  };

  // Update response - need to check if this is still used in the forms
  const updateResponse = (index, field, value) => {
    const updatedResponses = [...newExercise.reponses];
    updatedResponses[index] = {
      ...updatedResponses[index],
      [field]: value,
    };
    setNewExercise((prev) => ({
      ...prev,
      reponses: updatedResponses,
    }));
  };

  // Add or update question
  const handleQuestionSubmit = async (e) => {
    e.preventDefault();
    // const token = localStorage.getItem('access'); // Not needed with RTK Query baseQuery
    try {
      if (editingQuestion) {
        await updateQuestion({
          id: editingQuestion.id,
          ...newQuestion,
        }).unwrap();
      } else {
        await addQuestion(newQuestion).unwrap();
      }
      setNewQuestion({
        html: "",
        is_published: false,
        maximum_marks: 4,
        technology: "",
        niveau: "",
        categorie: "",
      });
      setEditingQuestion(null);
      // fetchQuestions(); // Not needed, RTK Query invalidatesTags handles refetching
    } catch (error) {
      console.error("Error submitting question:", error);
    }
  };

  // Edit question
  const handleEditQuestion = (q) => {
    setEditingQuestion(q);
    setNewQuestion({
      html: q.html,
      is_published: q.is_published,
      maximum_marks: q.maximum_marks,
      technology: q.technology,
      niveau: q.niveau,
      categorie: q.categorie,
    });
  };

  // Delete question
  const handleDeleteQuestion = async (id) => {
    if (window.confirm("Supprimer cette question ?")) {
      try {
        await deleteQuestion(id).unwrap();
        // fetchQuestions(); // Not needed, RTK Query invalidatesTags handles refetching
      } catch (error) {
        console.error("Error deleting question:", error);
      }
    }
  };

  // --- End Refactored Handlers ---

  return (
    <div className="coach-dashboard">
      {" "}
      {/* Main container with flex column */}
      <div className={`sidebar ${isSidebarOpen ? "collapsed" : ""}`}>
        {" "}
        {/* Sidebar */}
        {/* <div className="sidebar-header">
          <h2>
            {!sidebarCollapsed && "Bakeli Training"}
            {sidebarCollapsed ? "<>" : ""}
          </h2>
          <button className="collapse-btn" onClick={toggleSidebar}>
            {sidebarCollapsed ? <FiChevronRight /> : <FiChevronLeft />}
          </button>
        </div> */}
        <nav className="sidebar-nav">
          {[
            /* Navigation items */
            {
              id: "dashboard",
              icon: <FiHome />,
              label: "Dashboard",
              path: ADMIN_DASHBOARD_PATH,
            },
            {
              id: "quizzes",
              icon: <FiCheckCircle />,
              label: "Quizz",
              path: `${ADMIN_DASHBOARD_PATH}/quizzes`,
            },
            {
              id: "bakelistes",
              icon: <FiUsers />,
              label: "Utilisateurs",
              path: `${ADMIN_DASHBOARD_PATH}/Utilisateurs`,
            },
            // {
            //   id: "leaderboard",
            //   icon: <FiAward />,
            //   label: "Leaderboard",
            //   path: `${ADMIN_DASHBOARD_PATH}/leaderboard`,
            // },
            {
              id: "test-niveau",
              icon: <FiLayers />,
              label: "Test de niveau",
              path: `${ADMIN_DASHBOARD_PATH}/test-niveau`,
            },
            // {
            //   id: "exercices-generes",
            //   icon: <FiCode />,
            //   label: "Exercices",
            //   path: `${ADMIN_DASHBOARD_PATH}/exercices-generes`,
            // },

            {
              id: "domaines",
              icon: <FiList />,
              label: "Domaines",
              path: `${ADMIN_DASHBOARD_PATH}/domaines`,
            },
            {
              id: "technologies",
              icon: <FiCode />,
              label: "Technologies",
              path: `${ADMIN_DASHBOARD_PATH}/technologies`,
            },
            {
              id: "niveaux",
              icon: <FiLayers />,
              label: "Niveaux",
              path: `${ADMIN_DASHBOARD_PATH}/niveaux`,
            },
            {
              id: "categories",
              icon: <FiList />,
              label: "Catégories",
              path: `${ADMIN_DASHBOARD_PATH}/categories`,
            },
            {
              id: "exercises",
              icon: <FiAward />,
              label: "Exercices",
              path: `${ADMIN_DASHBOARD_PATH}/exercises`,
            }, // This should also be nested
            {
              id: "questions",
              icon: <FiEdit2 />,
              label: "Questions",
              path: `${ADMIN_DASHBOARD_PATH}/questions`,
            }, // This should also be nested
            {
              id: "parcours",
              icon: <FiMapPin />,
              label: "Parcours",
              path: `${ADMIN_DASHBOARD_PATH}/parcours`,
            },
          ].map((item) => {
            // Added curly braces to use block body
            //console.log("Navigating to:", item.path); // Log the path - We can remove this later
            return (
              <Link // Use Link for navigation
                key={item.id}
                to={item.path} // Use full path for navigation
                className={`nav-item ${
                  isNavLinkActive(item.path) ? "active" : ""
                }`} // Use isNavLinkActive
                // Remove onClick handler
                // onClick={() => setActiveSection(item.id)}
              >
                {item.icon}
                {!isSidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="dashboard-content-area">
        {" "}
        {/* Content area with flex row */}
        <DashboardHeader
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />{" "}
        {/* Header component */}
        <div className="main-dashboard-content">
          {" "}
          {/* Main Content Area (fills remaining space) */}
          <Outlet /> {/* This is where nested routes will render */}
          {/* Removed all content that was previously inside the <Routes> component */}
        </div>{" "}
        {/* Main Content Area (fills remaining space) */}
      </div>{" "}
      {/* Content area with flex row */}
    </div>
  );
};

export default CoachDashboard;
